import { type ReactNode } from 'react'
import { Box, Button, Chip, Paper, Stack, Tooltip, Typography } from '@mui/material'

export function TitoloPagina({ titolo, sottotitolo, azioni }: { titolo: string; sottotitolo?: string; azioni?: ReactNode }) {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ justifyContent: 'space-between', alignItems: { sm: 'center' } }}>
      <Box>
        <Typography variant="h5" component="h1">{titolo}</Typography>
        {sottotitolo && <Typography color="text.secondary">{sottotitolo}</Typography>}
      </Box>
      {azioni}
    </Stack>
  )
}

/** Sezione prevista ma non ancora costruita: si dice cosa fara' e da cosa dipende. */
export function PaginaInArrivo({ titolo, descrizione, dipende }: { titolo: string; descrizione: string; dipende: string }) {
  return (
    <Stack spacing={2.5}>
      <TitoloPagina titolo={titolo} />
      <Paper variant="outlined" sx={{ p: 3, maxWidth: 640 }}>
        <Chip label="In arrivo" color="secondary" size="small" sx={{ mb: 1.5 }} />
        <Typography sx={{ mb: 1 }}>{descrizione}</Typography>
        <Typography variant="body2" color="text.secondary">{dipende}</Typography>
      </Paper>
    </Stack>
  )
}

export function PaginaNonTrovata() {
  return (
    <Stack spacing={1}>
      <Typography variant="h5" component="h1">Pagina non trovata</Typography>
      <Typography color="text.secondary">L'indirizzo non corrisponde a nessuna sezione del portale.</Typography>
    </Stack>
  )
}

/** Funzione prevista ma non ancora costruita: visibile, spenta, con il motivo. */
export function InArrivo({ etichetta }: { etichetta: string }) {
  return (
    <Tooltip title="In arrivo">
      <span>
        <Button size="small" disabled>
          {etichetta}
        </Button>
      </span>
    </Tooltip>
  )
}
